import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";

export const BasicMuiTableStyled = ({
  data,
  columns,
  tableFooter,
  styleFunc,
  tableStyle = {},
  disableDefaultStyle = false,
}) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "none",
        backgroundColor: "#F5F8FC",
        borderRadius: disableDefaultStyle && "0px",
      }}
    >
      <Table sx={{ minWidth: 650, ...tableStyle }} aria-label="simple table">
        <TableHead>
          <TableRow
            sx={{
              ".css-191a0o-MuiTableCell-root": {
                padding: "10px 8px",
              },
            }}
          >
            {columns.map((item) => (
              <TableCell>{item.header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow
              key={index}
              sx={{
                ...(styleFunc && styleFunc(item)),
                border: disableDefaultStyle ? "none" : "1px solid #DFE8F2",
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              {columns.map((column) => (
                <>
                  <TableCell
                    sx={{
                      padding: "10px 8px",
                      borderBottom: "1px solid #DFE8F2",
                    }}
                  >
                    {column.cell(item, index)}
                  </TableCell>
                </>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TableFooter>{tableFooter}</TableFooter>
    </TableContainer>
  );
};
